import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';

export default function AccountAddressField({
  value,
  error,
  setValue,
  setError,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    // if (newValue === '') {
    //   setError('Address cannot be blank');
    // } else {
    //   setError(false);
    // }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Address'
          id='address'
          aria-describedby='address-helper-text'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          variant='standard'
        />
        {error ? (
          <FormHelperText id='address-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='address-helper-text'>
            Enter your address
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
